import { useEffect, useState } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { useLoading } from '../../../../hooks/loading'
import api from '../../../../services/api'
import { FormPaymentGateways } from '../components/Form'
import { apiList } from '../domain/api'
import { breadcrumbUpdate } from '../domain/breadcrumb'
import { toolsUpdate } from '../domain/tools'
import { nameActions } from '../domain/info'
import { useToast } from '../../../../hooks/toast'
import Container from '../../../../components/Container'

const PaymentGatewaysUpdate = (): JSX.Element => {
  const { addToast } = useToast()
  const location = useLocation()
  const history = useHistory()
  const { id } = useParams<{ id: string }>()
  const { activeLoading, disableLoading } = useLoading()
  const [paymentGatewaysItem, setPaymentGatewaysItem] = useState<{
    id: string
    paymentModule: {
      id: number
    }
    payment_module_id: number
    type: string
  }>()

  useEffect(() => {
    async function loadData() {
      activeLoading()
      try {
        const response = await api.get(apiList(id))
        const { data } = response
        setPaymentGatewaysItem(data)
        disableLoading()
      } catch (err) {
        const [, baseUrl, path] = location.pathname.split('/')
        disableLoading()
        addToast({
          type: 'error',
          title: 'Error ao carregar o via de pagamento',
          description:
            'Houve um error ao carregar o via de pagamento, tente novamente mais tarde!'
        })
        if (path.includes('update')) {
          history.push(`/${baseUrl}`)
        } else {
          history.push(`/${baseUrl}/${path}`)
        }
      }
    }
    loadData()
  }, [activeLoading, addToast, disableLoading, history, id, location.pathname])

  return (
    <Container
      pageTitle={nameActions.update.name}
      breadcrumb={breadcrumbUpdate}
      tools={toolsUpdate}
    >
      <FormPaymentGateways
        typeForm="update"
        initialValues={{
          idUpdate: Number(paymentGatewaysItem?.id),
          ...paymentGatewaysItem
        }}
      />
    </Container>
  )
}

export default PaymentGatewaysUpdate
